/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DataUsageDetailDTO { 
    /**
     * Data usage of TSS log in bytes
     */
    tssLog?: number;
    /**
     * Data usage of cash point closing (DFKA/DSFinV-K + attachments) in bytes
     */
    cashPointClosing?: number;
    /**
     * Data usage of procedural documentation in bytes
     */
    proceduralDocumentation?: number;
    /**
     * Data usage of open archive in bytes
     */
    openArchive?: number;
}

export class ClsDataUsageDetailDTO { 
    /**
     * Data usage of TSS log in bytes
     */
    tssLog?: number = undefined;
    /**
     * Data usage of cash point closing (DFKA/DSFinV-K + attachments) in bytes
     */
    cashPointClosing?: number = undefined;
    /**
     * Data usage of procedural documentation in bytes
     */
    proceduralDocumentation?: number = undefined;
    /**
     * Data usage of open archive in bytes
     */
    openArchive?: number = undefined;
}

